<template>
    <footer class="footer-root">
        <!-- Wavy background decoration (optional CSS implementation to match PC design) -->
        <div class="footer-bg-wave pc-only"></div>

        <div class="footer-container">
            <!-- PC Layout -->
            <div class="footer-pc-layout pc-only">
                <div class="footer-left">
                    <div class="footer-logo">
                        <img src="@/assets/logo.png" alt="XigFor" />
                    </div>
                    <div class="footer-contact-links">
                        <a href="mailto:info@xigfor.com" class="footer-link-icon-link">
                            <img src="@/assets/email.png" class="footer-link-icon-img" alt="email" />
                            <span>info@xigfor.com</span>
                        </a>
                        <a href="https://www.facebook.com/share/1C1H5yGgGQ/?mibextid=wwXIfr" class="footer-link-icon-link" target="_blank" rel="noopener">
                            <img src="@/assets/facebook.png" class="footer-link-icon-img" alt="Facebook" />
                            <span>Facebook</span>
                        </a>
                        <a href="https://x.com/xigfor?s=21" class="footer-link-icon-link" target="_blank" rel="noopener">
                            <img src="@/assets/X.png" class="footer-link-icon-img" alt="X (Twitter)" />
                            <span>X</span>
                        </a>
                        <a href="https://www.reddit.com/u/XigFor/s/Uw8UQnBWbe" class="footer-link-icon-link" target="_blank" rel="noopener">
                            <img src="@/assets/reddit.png" class="footer-link-icon-img" alt="Reddit" />
                            <span>Reddit</span>
                        </a>
                    </div>
                    <div class="footer-apps">
                        <img src="@/assets/googleplay.png" alt="Google Play" class="footer-app-btn" />
                        <img src="@/assets/appstore.png" alt="App Store" class="footer-app-btn" />
                        <img src="@/assets/android.png" alt="Universal APK" class="footer-app-btn" />
                    </div>
                    <div class="footer-copyright">Copyright @ 2025-2026 XIGFOR.INC. All Rights Reserved.</div>
                </div>

                <div class="footer-right">
                    <div class="footer-col" style="flex: 1.2">
                        <div class="footer-title">User Rewards</div>
                        <div class="footer-links">
                            <router-link to="/content/growth-program" class="footer-link">Growth Program Overview</router-link>
                            <router-link to="/content/smartrewards-rules" class="footer-link">SmartRewards Rules & Terms</router-link>
                            <router-link to="/content/smartrewards-terms" class="footer-link">SmartRewards Terms & Conditions</router-link>
                        </div>

                        <div class="footer-title mt-40">Compliance</div>
                        <div class="footer-links">
                            <router-link to="/info/compliance-standards" class="footer-link">Compliance Standards & User Protection</router-link>
                            <router-link to="/content/platform-disclaimer" class="footer-link">Platform Disclaimer</router-link>
                        </div>
                    </div>

                    <div class="footer-col" style="flex: 0.8">
                        <div class="footer-title">Legal</div>
                        <div class="footer-links">
                            <!-- <a href="/terms-of-service" class="footer-link" target="_blank" rel="noopener">Terms of Service</a> -->
                            <!-- <a href="/privacy-policy" class="footer-link" target="_blank" rel="noopener">Privacy Policy</a> -->
                            <router-link to="/content/terms-of-service" class="footer-link">Terms of Service</router-link>
                            <router-link to="/content/privacy-policy" class="footer-link">Privacy Policy</router-link>
                            <router-link to="/content/intellectual-property" class="footer-link">Intellectual Property Policy</router-link>
                        </div>
                    </div>
                </div>
            </div>

            <!-- H5 Layout -->
            <div class="footer-h5-layout h5-only">
                <div class="h5-section">
                    <div class="h5-title">
                        <div class="h5-red-bar"></div>
                        <img src="@/assets/useapp.png" class="h5-icon-1" alt="Use APP" />
                        <span>Use APP</span>
                    </div>
                    <div class="h5-content">
                        <div class="footer-apps">
                            <img src="@/assets/googleplay.png" alt="Google Play" class="footer-app-btn" />
                            <img src="@/assets/appstore.png" alt="App Store" class="footer-app-btn" />
                            <img src="@/assets/android.png" alt="Universal APK" class="footer-app-btn" />
                        </div>
                    </div>
                </div>

                <div class="h5-divider"></div>

                <div class="h5-section">
                    <div class="h5-title">
                        <div class="h5-red-bar"></div>
                        <img src="@/assets/h5-footer-3.png" class="h5-icon" alt="Contact Us" />
                        <span>Contact Us</span>
                    </div>
                    <div class="h5-content">
                        <a href="mailto:info@xigfor.com" class="h5-text-link">info@xigfor.com</a>
                    </div>
                </div>

                <div class="h5-divider"></div>

                <div class="h5-section">
                    <div class="h5-title">
                        <div class="h5-red-bar"></div>
                        <img src="@/assets/h5-footer-1.png" class="h5-icon" alt="User Rewards" />
                        <span>User Rewards</span>
                    </div>
                    <div class="h5-content h5-links">
                        <router-link to="/content/growth-program" class="h5-text-link">Growth Program Overview</router-link>
                        <router-link to="/content/smartrewards-rules" class="h5-text-link">SmartRewards Rules & Terms</router-link>
                        <router-link to="/content/smartrewards-terms" class="h5-text-link">SmartRewards Terms & Conditions</router-link>
                    </div>
                </div>

                <div class="h5-divider"></div>

                <div class="h5-section">
                    <div class="h5-title">
                        <div class="h5-red-bar"></div>
                        <img src="@/assets/h5-footer-2.png" class="h5-icon" alt="Compliance" />
                        <span>Compliance</span>
                    </div>
                    <div class="h5-content h5-links">
                        <router-link to="/info/compliance-standards" class="h5-text-link">Compliance Standards & User Protection</router-link>
                        <router-link to="/content/platform-disclaimer" class="h5-text-link">Platform Disclaimer</router-link>
                    </div>
                </div>

                <div class="h5-divider"></div>

                <div class="h5-section">
                    <div class="h5-title">
                        <div class="h5-red-bar"></div>
                        <img src="@/assets/h5-footer-4.png" class="h5-icon" alt="Legal" />
                        <span>Legal</span>
                    </div>
                    <div class="h5-content h5-links">
                        <router-link to="/content/terms-of-service" class="h5-text-link">Terms of Service</router-link>
                        <router-link to="/content/privacy-policy" class="h5-text-link">Privacy Policy</router-link>
                        <router-link to="/content/intellectual-property" class="h5-text-link">Intellectual Property Policy</router-link>
                    </div>
                </div>

                <div class="h5-copyright">Copyright @ 2024-2026 XIGFOR.INC. All Rights Reserved.</div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
.footer-root {
    width: 100%;
    background: #ffffff;
    position: relative;
    overflow: hidden;
    border-top: 1px solid #f2f2f2;
}

/* Simulated wavy background for PC */
.footer-bg-wave {
    position: absolute;
    top: 40%;
    left: -10%;
    width: 120%;
    height: 200px;
    background: radial-gradient(ellipse at center, rgba(230, 230, 250, 0.3) 0%, rgba(255, 255, 255, 0) 70%);
    transform: rotate(-5deg);
    pointer-events: none;
    z-index: 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
}

.pc-only {
    display: flex;
}

.h5-only {
    display: none;
}

/* =========================================
   PC Layout Styles
========================================= */
.footer-pc-layout {
    padding: 60px 20px 40px 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.footer-left {
    flex: 0 0 35%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.footer-logo img {
    height: 50px;
    object-fit: contain;
}

.footer-contact-links {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
}

.footer-link-icon-link {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #555;
    text-decoration: none;
    font-size: 16px;
    font-family: inherit;
    transition: all 0.3s ease;
}

.footer-link-icon-link:hover {
    color: #ff5e3a;
    transform: translateX(4px);
}

.footer-link-icon-img {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.footer-apps {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 8px;
}

.footer-app-btn {
    height: 32px;
    cursor: pointer;
    transition: transform 0.2s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
}

/* .footer-app-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
} */

.footer-copyright {
    margin-top: 24px;
    color: #999;
    font-size: 13px;
}

.footer-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    gap: 60px;
    padding-top: 10px;
}

.footer-col {
    display: flex;
    flex-direction: column;
}

.footer-title {
    font-size: 22px;
    font-weight: 500;
    color: #090f4e; /* Dark navy from design */
    margin-bottom: 24px;
    /* font-family: 'Poppins', 'Inter', sans-serif; */
}

.mt-40 {
    margin-top: 40px;
}

.footer-links {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.footer-link {
    color: #777;
    text-decoration: none;
    font-size: 15px;
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: #ff5e3a;
}

/* =========================================
   H5 Layout Styles
========================================= */
@media (max-width: 900px) {
    .pc-only {
        display: none !important;
    }

    .h5-only {
        display: block;
    }

    .footer-root {
        background: #fff;
        border-top: none;
    }

    .footer-container {
        padding: 0;
    }

    .footer-h5-layout {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
    }

    .h5-section {
        padding: 24px 0 16px 0;
    }

    .h5-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: #777777;
        margin-bottom: 16px;
        font-family: 'Sansita', sans-serif;
    }

    .h5-red-bar {
        width: 3px;
        height: 14px;
        background-color: #f75d77;
        border-radius: 6px;
        margin-right: 12px;
    }

    .h5-icon {
        width: 18px;
        height: 18px;
        margin-right: 8px;
        object-fit: contain;
    }
    .h5-icon-1 {
        width: 12px;
        height: 18px;
        margin-right: 8px;
        object-fit: contain;
    }

    .h5-content {
        padding-left: 40px; /* Indent under title text appropriately */
    }

    .h5-links {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .h5-text-link {
        color: #9b9ca5;
        text-decoration: none;
        font-size: 12px;
        display: inline-block;
    }

    .h5-text-link:hover {
        color: #f7455d;
    }

    .h5-divider {
        height: 1px;
        background-color: #f2f2f2;
        margin: 0;
        width: 100%;
    }

    .h5-copyright {
        text-align: center;
        color: #bbb;
        font-size: 12px;
        margin-top: 32px;
        margin-bottom: 32px;
    }

    .footer-apps {
        margin-top: 0;
        gap: 10px;
    }

    .footer-app-btn {
        height: 25px;
    }
}
</style>
